/*
  Product page collapsible tabs (Description, Shipping, ...): opening one closes the others,
  but only among these tabs. Other collapsibles in the section ("Pairs well with") are left
  alone. Runs after the tab's own click handler (theme-global.js), which does the toggling.
*/
if (!window.MProductCollapsible) {
  window.MProductCollapsible = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-product-tab] > [data-trigger]');
    if (!trigger) return;
    const tab = trigger.parentElement;
    if (!tab.selected) return;

    const scope = tab.closest('[data-section-id]') || document;
    scope.querySelectorAll('[data-product-tab]').forEach((other) => {
      if (other !== tab && other.selected && typeof other.close === 'function') other.close();
    });
  });
}
